import React from 'react'
import img from '../images/showimage1.webp'
import img1 from '../images/showimage2.webp'
import img2 from '../images/showimage3.webp'

function SloganComponent() {
    return (
        <div id='About'>
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
            <div className="container text-center py-4">
                <div className="row">
                    <div className="col">
                        <div className='text-center headCenter mx-auto'>
                            <span className="section-label d-block mb-2">Our Philosophy</span>
                            <h3 className='whyHeadFont'>Connecting Hearts Through Henna Creations.</h3>
                            <p className='whyPara mb-4 mt-3'>
                                Mehandi goes beyond intricate designs — it's a powerful means of connecting hearts and cultures.
                                With every brush of henna paste, I bridge the gaps between traditions and communities.
                                Each design tells a story, unites individuals in celebration, and honors the rich tapestry
                                of our world's diverse cultures.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='show-images-section'>
                <div className="container">
                    <div className="row g-3">
                        <div className="col-4">
                            <img src={img} className="img-fluid rounded" alt="Mehandi Design" />
                        </div>
                        <div className="col-4">
                            <img src={img2} className="img-fluid rounded" alt="Mehandi Design" />
                        </div>
                        <div className="col-4">
                            <img src={img1} className="img-fluid rounded" alt="Mehandi Design" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container text-center py-5">
                <div className="row">
                    <div className="col">
                        <div className='text-center headCenter mx-auto'>
                            <span className="section-label d-block mb-2">Our Craft</span>
                            <h3 className='whyHeadFont'>Elegance Meets Tradition in Every Henna Stroke.</h3>
                            <p className='whyPara mt-3'>
                                At the heart of my Mehandi artistry lies the delicate dance between tradition and elegance.
                                With each carefully crafted henna stroke, I breathe life into timeless customs, infusing
                                them with a touch of contemporary grace. Through my art, I strive to create a harmonious
                                fusion where beauty and tradition converge seamlessly.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
        </div>
    )
}

export default SloganComponent
